import { z } from 'zod';

export const AuthProvider = z.enum(['github', 'google']);
export type AuthProvider = z.infer<typeof AuthProvider>;

export const CurrentUser = z.object({
  id: z.string(),
  email: z.string().email(),
  name: z.string(),
  avatar_url: z.string().url().nullable(),
  github_id: z.string().nullable(),
  google_id: z.string().nullable(),
  created_at: z.string(),
});
export type CurrentUser = z.infer<typeof CurrentUser>;
